<template>
  <ui-button class="button-more" :to="to" :backgroundColor="backgroundColor" color="#FFFFFF">
        <div slot="title">{{ $t(title) }}</div>
  </ui-button>

</template>

<script>
import UiButton from '../UiButton.vue';

export default {
  name: 'button-more',
  props:{
    title:{default:"no title prop set."},
    to:{default:""},
    backgroundColor:{default:"#50c0db"},
  },
  data:function(){
    return {
    }
  },
  methods:{
  },
  mounted:function(){
    
  },
  components:{
    UiButton
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.button-more{
  display:block;
  width:auto;
  text-align:center;
}

</style>
